export interface Session {
    universeSign: string;
}

export const SessionName = 'ENSEIGNE';
